import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import img from '../assets/about.png'; 
import { 
  faHeart, 
  faTools, 
  faTruck, 
  faStar, 
  faHardHat, 
  faRulerCombined, 
  faShieldAlt,
  faHome,
  faBuilding,
  faUsers,
  faCalendarCheck
} from '@fortawesome/free-solid-svg-icons';
import video from '../assets/about-video.mp4'; 

const About = () => {
    return (
        <div className='bg-gray-50'>
            {/* Hero Header */}
            <div className="w-full h-[400px] mb-10 header flex justify-center items-center relative">
                <div className="absolute inset-0 bg-black opacity-50"></div>
                <div className="text-center px-3 mt-10 relative z-10" data-aos="zoom-in">
                    <p className="text-3xl lg:text-5xl font-extrabold text-white mb-5" >Building Excellence Since Day One</p>
                    <p className="text-lg text-white">Quality construction, innovative solutions, and unwavering commitment to every project.</p>
                </div>
            </div>

            {/* About Us Section */}
            <div className="my-10 px-5 lg:px-32" data-aos="zoom-out">
                <h1 className="text-4xl font-bold text-center text-yellow-600" >About Our Company</h1>
                <p className='text-center text-lg mt-10 text-gray-700 font-sans'>"At KA Construction Solutions LTD, we specialize in turning your vision into reality. With expertise in residential, commercial, and industrial construction, we bring innovation, quality, and reliability to every project we undertake."</p>
            </div>

            {/* Main Content */}
            <div className="px-5 lg:px-32 mt-10">
                <div className="grid lg:grid-cols-2 gap-8">
                    <div data-aos="fade-left">
                        <h1 className="mb-3 text-3xl font-bold text-gray-800"  >
                            "KA Construction Solutions LTD"
                        </h1>
                        <p className="text-gray-700 text-lg lg:text-xl mt-5 lg:mt-10">
                            At KA Construction Solutions LTD, we are committed to building structures that stand the test of time. Founded on principles of integrity, craftsmanship, and innovation, we approach every project with meticulous attention to detail and a passion for excellence. Our team of skilled professionals combines traditional building techniques with modern technology to deliver superior results that exceed client expectations.
                        </p>
                        <p className="text-gray-700 text-lg lg:text-xl mt-5">
                            Whether it's a custom home, commercial building, or renovation project, we work closely with our clients to ensure their vision becomes a reality. We believe in transparent communication, strict quality control, and timely project delivery.
                        </p>
                    </div>

                    <div data-aos="fade-right">
                        <img src={img} alt="Construction Site" className="w-full h-full object-cover rounded-lg shadow-lg" />
                    </div>
                </div>

                {/* Construction Video */}
                {/* <div className='my-10 flex justify-center' data-aos="zoom-in">
                    <div className="relative w-full max-w-4xl">
                        <video width="840" height="560" autoPlay loop muted controls className="rounded-lg shadow-xl">
                            <source src={video} type="video/mp4" />
                            Your browser does not support the video tag.
                        </video>
                        <div className="absolute inset-0 bg-gradient-to-t from-yellow-900/20 to-transparent rounded-lg"></div>
                    </div>
                </div> */}

                {/* Our Mission */}
                <div className="mt-10 mb-8" data-aos="fade-down">
                    <h2 className="text-3xl text-yellow-600 font-bold text-center mb-5" >Our Mission</h2>
                    <p className="text-center text-xl text-gray-700 font-sans mb-4">
                        "To deliver exceptional construction services through innovation, quality craftsmanship, and unwavering commitment to client satisfaction."
                    </p>
                    <p className="text-center text-xl text-gray-700 font-sans">
                        We aim to build structures that not only meet functional requirements but also inspire and endure for generations.
                    </p>
                </div>

                {/* Services Cards */}
                <div className='mt-10 pb-10 grid lg:grid-cols-4 gap-5' data-aos="fade-right">
                    <div className='bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300 border-l-4 border-yellow-600' >
                        <FontAwesomeIcon icon={faHome} className="text-4xl text-yellow-600 mb-5" />
                        <h3 className='text-xl font-bold text-gray-800 mb-3'>Residential Construction</h3>
                        <p className='text-gray-600 font-sans text-base'>Custom homes, renovations, and additions designed with precision and built to the highest standards of quality.</p>
                    </div>

                    <div className='bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300 border-l-4 border-yellow-600'>
                        <FontAwesomeIcon icon={faBuilding} className="text-4xl text-yellow-600 mb-5" />
                        <h3 className='text-xl font-bold text-gray-800 mb-3'>Commercial Projects</h3>
                        <p className='text-gray-600 font-sans text-base'>Office buildings, retail spaces, and commercial developments executed with efficiency and expertise.</p>
                    </div>

                    <div className='bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300 border-l-4 border-yellow-600'>
                        <FontAwesomeIcon icon={faTools} className="text-4xl text-yellow-600 mb-5" />
                        <h3 className='text-xl font-bold text-gray-800 mb-3'>Expert Craftsmanship</h3>
                        <p className='text-gray-600 font-sans text-base'>Skilled professionals using advanced techniques and quality materials for superior results.</p>
                    </div>

                    <div className='bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300 border-l-4 border-yellow-600'>
                        <FontAwesomeIcon icon={faCalendarCheck} className="text-4xl text-yellow-600 mb-5" />
                        <h3 className='text-xl font-bold text-gray-800 mb-3'>Timely Completion</h3>
                        <p className='text-gray-600 font-sans text-base'>Projects delivered on schedule with meticulous planning and project management.</p>
                    </div>
                </div>

                {/* Values Section */}
                <div className='mt-10 mb-16 grid lg:grid-cols-3 gap-8' data-aos="fade-up">
                    <div className="text-center p-6 bg-white rounded-lg shadow-md">
                        <div className="inline-flex items-center justify-center w-16 h-16 bg-gray-100 rounded-full mb-4">
                            <FontAwesomeIcon icon={faShieldAlt} className="text-yellow-600 text-2xl" />
                        </div>
                        <h3 className='text-xl font-bold text-gray-800 mb-3'>Safety First</h3>
                        <p className='text-gray-600'>Comprehensive safety protocols and training to ensure a secure work environment on every site.</p>
                    </div>

                    <div className="text-center p-6 bg-white rounded-lg shadow-md">
                        <div className="inline-flex items-center justify-center w-16 h-16 bg-gray-100 rounded-full mb-4">
                            <FontAwesomeIcon icon={faUsers} className="text-yellow-600 text-2xl" />
                        </div>
                        <h3 className='text-xl font-bold text-gray-800 mb-3'>Client Collaboration</h3>
                        <p className='text-gray-600'>Working closely with clients throughout the process to ensure their vision is realized.</p>
                    </div>

                    <div className="text-center p-6 bg-white rounded-lg shadow-md">
                        <div className="inline-flex items-center justify-center w-16 h-16 bg-gray-100 rounded-full mb-4">
                            <FontAwesomeIcon icon={faRulerCombined} className="text-yellow-600 text-2xl" />
                        </div>
                        <h3 className='text-xl font-bold text-gray-800 mb-3'>Attention to Detail</h3>
                        <p className='text-gray-600'>Meticulous planning and execution to ensure every aspect of the project meets our high standards.</p>
                    </div>
                </div>
            </div>

            {/* CTA Section */}
            <div className="bg-gradient-to-r from-yellow-600 to-yellow-700 text-white py-16 px-5 lg:px-32">
                <div className="text-center" data-aos="fade-up">
                    <h2 className="text-3xl font-bold mb-6">Ready to Build Your Vision?</h2>
                    <p className="text-xl mb-8 max-w-3xl mx-auto">
                        Whether you're planning a new construction project or renovating an existing space, our team is ready to bring your ideas to life with expertise and dedication.
                    </p>
                    <button className="bg-white text-yellow-700 font-bold py-3 px-8 rounded-lg hover:bg-gray-100 transition-colors duration-300 text-lg">
                        Start Your Project
                    </button>
                </div>
            </div>
        </div>
    );
};

export default About;